import { useHeaderInfomation } from "lib/hooks/useHeaderInfomation";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import useWindowSize from "react-use/lib/useWindowSize";
import TitleDisplay from "./TitleDisplay";

type agents = {
  company_id: number
}

interface Props {
  title: string;
  address: string;
  id: number;
  isLDC: boolean;
  isLoggedIn: boolean;
  setShowAllAgentContacts: any;
  showAllAgentContacts: boolean;
  type: string;
  showPage: boolean;
  researched_website: string;
  agents: agents[]
}

type TitelDisplayProps = {
  id: number;
  isLDC: boolean;
  isLoggedIn: boolean;
  headerHeight: number;
  mainTitle: string;
  addressText: string;
  agents: any;
  title: string;
  researched_website: string;
}

const Title = ({ id, title, address, isLDC, isLoggedIn, agents, researched_website, setShowAllAgentContacts, showAllAgentContacts, type, showPage  }: Props) => {

  let dispatch = useDispatch();
  const { height: headerHeight } = useHeaderInfomation();
  const { width: windowWidth } = useWindowSize();
  const [stuck, setStuck] = useState(false);

  const getPosition = () => {
      let elem = document.getElementById(id);
      if (!elem) {
        return;
      }
      let bound = elem.getBoundingClientRect();
      let top = bound.top;

      if (windowWidth > 768) {
        if (top <= 70) {
          setStuck(true);
        } else {
          setStuck(false);
        }
      } else {
        setStuck(false);
      }
  };

  useEffect(() => {
    window.addEventListener("scroll", getPosition, {passive: true});

    return () => {
      window.removeEventListener("scroll", getPosition);
    };
  }, [headerHeight]);

  let addressText: string = '';

  if(address) {
    addressText = address;
  }


  const getDisplayTitle = (title?: string, address?: { firstLine?: string } | string): string => {
    return title  ?? 'Shop to rent';
  };

  let mainTitle = getDisplayTitle(title, address);

  const props: TitelDisplayProps = {
    isLDC,
    headerHeight: 70,
    addressText,
    title,
    id,
    mainTitle,
    isLoggedIn,
    agents,
    researched_website
  }

  return (
    <TitleDisplay {...props} type={type} dispatch={dispatch} stuck={stuck} setShowAllAgentContacts={setShowAllAgentContacts} showAllAgentContacts={showAllAgentContacts} showPage={showPage} />
  );
};

export default Title;
